module.exports = __webpack_public_path__ + "img/46800.6df4513b.jpg";